import { Component, Input, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatTableModule } from '@angular/material/table';
import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';
import { ReturnHistoryEntryModel, HistoryType } from '../../../../domain/models/return.model';
import { CasheringService } from '../../../../domain/services/cashering/cashering.service';

@Component({
  selector: 'app-return-history',
  standalone: true,
  imports: [
    CommonModule,
    MatTableModule,
    MatChipsModule,
    MatIconModule
  ],
  templateUrl: './return-history.component.html',
  styleUrls: ['./return-history.component.css']
})
export class ReturnHistoryComponent implements OnInit {
  /** Initial snapshot (from the loaded return); refreshed live when returnId is set. */
  @Input() history: ReturnHistoryEntryModel[] = [];
  @Input() returnId?: number;

  private casheringService = inject(CasheringService);

  displayedColumns: string[] = ['date', 'type', 'user', 'attribute', 'oldValue', 'newValue'];
  HistoryType = HistoryType;

  ngOnInit(): void {
    if (this.returnId != null) {
      this.casheringService.getHistory(this.returnId).subscribe({
        next: (rows: any[]) => { this.history = (rows ?? []).map(r => this.toEntry(r)); },
        error: () => { /* keep the snapshot already passed in */ },
      });
    }
  }

  /** Maps the backend ReturnHistoryDto (timestamp/actionType/userName) to the table model. */
  private toEntry(dto: any): ReturnHistoryEntryModel {
    return {
      id: dto.id,
      date: dto.timestamp ?? dto.date,
      type: this.toHistoryType(dto.actionType ?? dto.type),
      user: dto.userName ?? dto.user ?? dto.userId ?? '',
      attribute: dto.attribute ?? '',
      oldValue: dto.oldValue ?? '',
      newValue: dto.newValue ?? '',
    };
  }

  private toHistoryType(action: string): HistoryType {
    switch (action) {
      case 'NOTE': return HistoryType.NOTE;
      case 'ATTACHMENT': return HistoryType.ATTACHMENT;
      case 'STATUS_CHANGE': return HistoryType.STATUS_CHANGE;
      default: return HistoryType.EDIT; // EDIT, FEE_*, ALLOWANCE_*, PAYMENT, SUBMISSION
    }
  }

  getTypeClass(type: HistoryType): string {
    switch (type) {
      case HistoryType.EDIT:
        return 'type-edit';
      case HistoryType.NOTE:
        return 'type-note';
      case HistoryType.ATTACHMENT:
        return 'type-attachment';
      case HistoryType.STATUS_CHANGE:
        return 'type-status';
      default:
        return '';
    }
  }
}
